import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import AttributesDataTable from 'components/attributes/AttributesDataTable';
import { convertQueryParamsIntoObject } from 'constant/Helpers';

const AttributesPage = () => {
  const [inputValues, setInputValues] = useState({
    searchKey: '',
  });
  const location = useLocation();

  useEffect(() => {
    if (location.search) {
      const queryObj = convertQueryParamsIntoObject(location.search);
      setInputValues(queryObj);
    }
  }, [location.search]);

  return (
    <div>
      <AttributesDataTable inputValues={inputValues} setInputValues={setInputValues} />
    </div>
  );
};

export default AttributesPage;
